module.exports = __webpack_public_path__ + "static/media/banner_mobile.cae8d94c.png";